import { sendRequest } from '../../hooks/requests/useRequest'

export async function getDetailCash(_id_branch) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `WorkOrder/DetailAmount/${_id_branch}`);

    if (response.code === 200)
        return response.data;
    else
        return response;
}

export async function createCash(_comments, _notAmount, _valid, _captureAmount, _first, _last, _branch) {

    let _body = {
        comments: _comments,
        amount: _notAmount === undefined ? 0 : _valid,
        capture_amount: _captureAmount,
        id_work_order_first: _first,
        id_work_order_last: _last,
        id_branch: _branch,
    };

    let data = JSON.stringify(_body);

    let requestOptions = {
        method: 'POST',
        body: data

    };

    const response = await sendRequest(requestOptions, "CashFlow/Create");

    if (response.code === 200)
        return response?.data;
    else {
        return response;
    }
}


export async function getGlobalCash(_date1, _date2) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `WorkOrder/ListGlobalPendingCash/${_date1}/${_date2}`);

    if (response.code === 200)
        return response.data;
    else
        return response;
}



export async function getCash(_date1, _date2) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `WorkOrder/ListGlobalCash/${_date1}/${_date2}`);

    if (response.code === 200)
        return response.data;
    else
        return response;
}

export async function createCashGlobal(_authorization_date, _id_cash) {

    let _body = {
        authorization_date: _authorization_date,
        id_cash: _id_cash,
    };

    let data = JSON.stringify(_body);

    let requestOptions = {
        method: 'POST',
        body: data

    };

    const response = await sendRequest(requestOptions, "CashFlow/CreateGlobal");

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else {
        return response;
    }


}


export async function getGlobalDetail(_id_branch, _date1, _date2) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `WorkOrder/DetailCreditCash/${_id_branch}?date_from=${_date1}&date_to=${_date2}&is_cash=1`);

    if (response.code === 200)
        return response.data;
    else
        return response;
}


export async function getGlobalDiscount(_date1, _date2) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `WorkOrder/ListGlobalDiscount/${_date1}/${_date2}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else {
        return response;
    }
}

export async function getGlobalBonus(_date1, _date2) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `WorkOrder/ListGlobalBonus/${_date1}/${_date2}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else {
        return response;
    }
}

export async function getGlobalCancell(_date1, _date2) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Reports/GetReportFilterCancell/${_date1}/${_date2}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else {
        return response;
    }
}


export async function getGlobalDevolution(_date1, _date2) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Reports/GetReportFilterDevolution/${_date1}/${_date2}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else {
        return response;
    }
}

export async function createCashExtemporaneous(_comments, amount_capture, _amount, _id_branch, _first, _last, _date, _id_user_extemporaneous, _fech) {

    let _body = {
        comments: _comments,
        amount: amount_capture,
        capture_amount: _amount,
        id_work_order_first: _first,
        id_work_order_last: _last,
        id_branch: _id_branch,
        is_extemporaneous: true,
        date_extemporaneous: _date,
        id_user_extemporaneous: _id_user_extemporaneous,
        date_cash: _fech
    };

    let data = JSON.stringify(_body);

    let requestOptions = {
        method: 'POST',
        body: data

    };

    const response = await sendRequest(requestOptions, "CashFlow/CreateExtemporaneous");

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else {
        return response;
    }
}


export async function getReportCredit(_date1, _date2, _idBranch) {
    const requestOptions = {
        method: "GET",
    };


    const response = await sendRequest(requestOptions, `WorkOrder/DetailHistoricCredit/${_date1}/${_date2}/${_idBranch === null ? 0 : _idBranch}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else {
        return response;
    }
}






